import * as React from 'react';
import {
  ChildPlayground16,
  CommerceObject16,
  Pet16,
  FastService16,
  Fitness16,
  Baby16,
  Office16,
  Hospital16,
  Pool16,
  Restaurant16,
  Book16,
  SPA16,
  SportPlayground16,
  Supermarket16,
  Parking16,
  Barrier16,
  Security16,
  Cctv16,
  Reception16,
  Extinguisher16,
  SecurityParking16,
  CloseArea16,
  Signaling16,
} from '@cian/ui-kit/icons';
import { EShortInfraType, EParkingType, ESecutiryType } from '../types/newbuilding/specificationsDetailed';

export const DETAILED_SPECIFICATIONS_ICON_MAP: { [id: string]: React.ReactNode } = {
  [EShortInfraType.Children]: <ChildPlayground16 />,
  [EShortInfraType.Commerce]: <CommerceObject16 />,
  [EShortInfraType.Dogs]: <Pet16 />,
  [EShortInfraType.Domestic]: <FastService16 />,
  [EShortInfraType.Fitness]: <Fitness16 />,
  [EShortInfraType.Kindergarten]: <Baby16 />,
  [EShortInfraType.Offices]: <Office16 />,
  [EShortInfraType.Polyclinic]: <Hospital16 />,
  [EShortInfraType.Pool]: <Pool16 />,
  [EShortInfraType.Recreation]: <ChildPlayground16 />, //
  [EShortInfraType.Restaurant]: <Restaurant16 />,
  [EShortInfraType.School]: <Book16 />,
  [EShortInfraType.Spa]: <SPA16 />,
  [EShortInfraType.Sport]: <SportPlayground16 />,
  [EShortInfraType.Supermarket]: <Supermarket16 />,
  [EParkingType.Guest]: <Parking16 />,
  [EParkingType.Standalone]: <Parking16 />,
  [EParkingType.Underground]: <Parking16 />,
  [ESecutiryType.Access]: <Barrier16 />,
  [ESecutiryType.AroundTheClock]: <Security16 />,
  [ESecutiryType.Camera]: <Cctv16 />,
  [ESecutiryType.Concierge]: <Reception16 />,
  [ESecutiryType.Fire]: <Extinguisher16 />,
  [ESecutiryType.Parking]: <SecurityParking16 />,
  [ESecutiryType.Perimetr]: <CloseArea16 />,
  [ESecutiryType.Signal]: <Signaling16 />,
};
